module.exports = __webpack_public_path__ + "static/img/menus.617efc1d.png";